import { AnyAction } from "redux";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  createShippingsTypeFailure,
  createShippingsTypeSuccess,
  editShippingsTypeFailure,
  editShippingsTypeSuccess,
  listShippingsTypeFailure,
  listShippingsTypeRequest,
  listShippingsTypeSuccess
} from "../actions/shippingsType";
import { ShippingsTypeActionsTypes } from "../types/ShippingsType.reducer.types";

import { SagaCustomError } from "@/common/types";
import { ShippingsTypeService } from "@/core/libs/api";
import { messageBarTypes } from "@/core/libs/message-bar";

const abortController = new AbortController();
const { signal } = abortController;

function* createShippingsType({ payload }: AnyAction) {
  const { values, setSubmitting, closePanel, isAdmin } = payload;
  const service = ShippingsTypeService(undefined, isAdmin);

  setSubmitting(true);

  try {
    const response = yield call(service.create, {
      params: { body: { ...values } },
      signal
    });

    if (response.error) {
      const error: SagaCustomError = new Error();
      error.statusCode = response.error.status;

      throw error;
    }

    yield put(
      createShippingsTypeSuccess({
        message: `Tipo de frete criado com sucesso.`,
        type: messageBarTypes.SUCCESS
      })
    );

    if (closePanel) {
      setTimeout(() => {
        closePanel();
      }, 1000);
    }

    // REFRESH LIST
    yield put(listShippingsTypeRequest(undefined, { isAdmin }));
  } catch (error) {
    yield put(
      createShippingsTypeFailure({
        code: error?.statusCode,
        message:
          "Não foi possível criar o tipo de frete com os dados informados",
        type: messageBarTypes.ERROR
      })
    );
  }

  setSubmitting(false);
}

function* editShippingsType({ payload }: AnyAction) {
  const { values, setSubmitting, closePanel, isAdmin } = payload;
  const service = ShippingsTypeService(undefined, isAdmin);

  setSubmitting(true);

  try {
    const response = yield call(service.edit, {
      params: { body: { ...values } },
      signal
    });

    if (response.error) {
      const error: SagaCustomError = new Error();
      error.statusCode = response.error.status;

      throw error;
    }

    yield put(
      editShippingsTypeSuccess({
        message: `Tipo de frete editado com sucesso.`,
        type: messageBarTypes.SUCCESS
      })
    );

    if (closePanel) {
      setTimeout(() => {
        closePanel();
      }, 1000);
    }

    // REFRESH LIST
    yield put(listShippingsTypeRequest(undefined, { isAdmin }));
  } catch (error) {
    yield put(
      editShippingsTypeFailure({
        code: error?.statusCode,
        message:
          "Não foi possível editar o tipo de frete com os dados informados",
        type: messageBarTypes.ERROR
      })
    );
  }

  setSubmitting(false);
}

function* listShippingsType({ payload }: AnyAction) {
  const { filter, isAdmin } = payload;
  const service = ShippingsTypeService(undefined, isAdmin);

  try {
    const params = { query: { page: 1, limit: 10 } };

    if (filter) {
      params.query = { ...params.query, ...filter };
    }

    const response = yield call(service.list, { params, signal });

    if (response.error) {
      throw new Error();
    }

    yield put(listShippingsTypeSuccess({ list: response.data }));
  } catch (error) {
    yield put(listShippingsTypeFailure());
  }
}

export default all([
  takeLatest(ShippingsTypeActionsTypes.CREATE_REQUEST, createShippingsType),
  takeLatest(ShippingsTypeActionsTypes.EDIT_REQUEST, editShippingsType),
  takeLatest(ShippingsTypeActionsTypes.LIST_REQUEST, listShippingsType)
]);
